import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import {
  getPartnerSplitSupplyNotice,
  importPartnerSplitSupplyNotices,
  issuePartnerSplitSupplyNoticeUploadUrl,
  listPartnerSplitSupplyNotices,
  previewPartnerSplitSupplyNoticeImport,
} from '@ebalance/proto/bffuser/v1/split_supply_plan_service-SplitSupplyPlanService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'
import { uploadNoticeImportFile } from '~/pages/SplitSupplyPlan/hooks/uploadNoticeImportFile'

/**
 * ファイル 1 つを受け取り先 (署名つき URL) へ上げて、 他社の通告値の取込の token を返す関数を返す
 * (手順は `uploadNoticeImportFile`)。
 */
export function useUploadPartnerNoticeFile(): (file: File) => Promise<string> {
  const { mutateAsync: issueUploadUrl } = useMutation(
    issuePartnerSplitSupplyNoticeUploadUrl,
  )
  return (file) =>
    uploadNoticeImportFile(file, (fileName) => issueUploadUrl({ fileName }))
}

/**
 * 取り込む内容の確認 (preview)。 何も書かず、 token も使い切らない (確認し直せる)。
 * 中身の問題 (誤り・取り込める地点が無い・上限超え) は成功の response に載って戻る。
 */
export function usePreviewPartnerNoticeImport(): InvalidatingMutationResultFor<
  typeof previewPartnerSplitSupplyNoticeImport
> {
  return useMutation(previewPartnerSplitSupplyNoticeImport)
}

/**
 * 確認した内容の取り込み。 成功したら他社の通告値の一覧と詳細を最新化する。
 */
export function useImportPartnerSplitSupplyNotices(): InvalidatingMutationResultFor<
  typeof importPartnerSplitSupplyNotices
> {
  return useInvalidatingMutation(importPartnerSplitSupplyNotices, [
    createConnectQueryKey({
      schema: listPartnerSplitSupplyNotices,
      cardinality: 'finite',
    }),
    createConnectQueryKey({
      schema: getPartnerSplitSupplyNotice,
      cardinality: 'finite',
    }),
  ])
}
